// extracted by mini-css-extract-plugin
export default {"gallery":"c-l_gH","gallery__header":"c-l_gJ","gallery__thumbs":"c-l_gK"};